import { TabsList as MuiTabsList, type TabsListProps } from '@mui/base'
import { clsx } from 'clsx'
import { type JSX } from 'react'

export const TabsList = (props: TabsListProps): JSX.Element => {
  const { className } = props

  return <MuiTabsList {...props} className={clsx('tabs-list', className)} />
}
